'use client';

import { tw } from '@repo/ui';

import { isClaimingAtom } from '@claim/atoms';

import { TableRow } from './table-row';

type UserAssets = {
  assetType: string;
  amountOfAssets: number;
  availableToClaim: number;
};

interface TableProps {
  data: UserAssets[];
  isLoading: boolean;
  isClaimActive: boolean;
}

export const Table: React.FC<TableProps> = ({
  data,
  isLoading,
  isClaimActive,
}) => {
  return (
    <>
      <table className='w-full border-collapse px-8 text-white md:mt-8'>
        <thead>
          <tr>
            <th
              className={tw(
                'px-4 py-2 text-left text-xs font-semibold text-white/50 md:text-sm',
              )}
            >
              QTY
            </th>
            <th
              className={tw(
                'px-4 py-2 text-left text-xs font-semibold text-white/50 md:text-sm',
              )}
            >
              {isClaimActive ? 'CLAIM' : 'COLLECTIBLES'}
            </th>
            <th
              className={tw(
                'px-4 py-2 text-right text-xs font-semibold text-white/50 md:text-sm',
              )}
            >
              $DOOD
            </th>
          </tr>
        </thead>

        {!isLoading ? (
          <tbody>
            {data.map((row, index) => (
              <TableRow
                key={index}
                {...row}
              />
            ))}
          </tbody>
        ) : null}
      </table>

      {isLoading ? (
        <div className='flex w-full flex-col gap-4 pb-8'>
          <div className='h-7 animate-pulse rounded-md bg-white/10'></div>
          <div className='h-7 animate-pulse rounded-md bg-white/10'></div>
          <div className='h-7 animate-pulse rounded-md bg-white/10'></div>
          <div className='h-7 animate-pulse rounded-md bg-white/10'></div>
        </div>
      ) : null}
    </>
  );
};
